import { createRouter, createWebHistory } from 'vue-router'
import Main from '../views/Main.vue'
import Login from '../views/Login.vue'
import Pay from '../views/Pay.vue'
import Market from '../views/Market.vue'
import Candlestick from '../views/Candlestick.vue'
import Trade from '../views/Trade.vue'
import Signal from '../views/Signal.vue'
import Trend from '../views/Trend.vue'
import Chat from '../views/Chat.vue'
import Me from '../views/Me.vue'
import Doc from '../views/Doc.vue'
import Block from '../views/Block.vue'
import Basic from '../views/Basic.vue'
import Return from '../views/Return.vue'
import Financial from '../views/Financial.vue'
import Technical from '../views/Technical.vue'
import Correlation from '../views/Correlation.vue'
import Regression from '../views/Regression.vue'
import Picking from '../views/Picking.vue'

const routes = [
  {
    path: '/',
    component: Main,
    children: [
      {
        path: '/',
        component: Market
      },
      {
        path: '/market',
        component: Market
      },
      {
        path: '/candlestick',
        component: Candlestick
      },
      {
        path: '/trade',
        component: Trade
      },
      {
        path: '/signal',
        component: Signal
      },
      {
        path: '/trend',
        component: Trend
      },
      {
        path: '/block',
        component: Block
      },
      {
        path: '/basic',
        component: Basic
      },
      {
        path: '/return',
        component: Return
      },
      {
        path: '/financial',
        component: Financial
      },
      {
        path: '/technical',
        component: Technical
      },
      {
        path: '/correlation',
        component: Correlation
      },
      {
        path: '/regression',
        component: Regression
      },
      {
        path: '/picking',
        component: Picking
      },
      {
        path: '/me',
        component: Me
      },
    ]
  },
  {
    path: '/doc',
    component: Doc
  },
  {
    path: '/pay',
    component: Pay
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/:any',
    redirect: '/login'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  base: "/mft_stock/",
  routes
})

export default router
